import { render, staticRenderFns } from "./Congreso.vue?vue&type=template&id=381142a5"
import script from "./Congreso.vue?vue&type=script&lang=js"
export * from "./Congreso.vue?vue&type=script&lang=js"
import style0 from "./Congreso.vue?vue&type=style&index=0&id=381142a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports